// extracted by mini-css-extract-plugin
module.exports = {"overlay":"CustomerModal_overlay__2R7X7","inputContainer":"CustomerModal_inputContainer__2OTod","feedback":"CustomerModal_feedback__1aotQ","text":"CustomerModal_text__29jyv"};